module.exports = __webpack_public_path__ + "img/GrE_TechBuildingHitpoints_ua.51690caf.webp";